import { connect } from 'react-redux'
import DataCorrectionV2Page from '../components/DataCorrectionV2Page'
import { actions } from '../modules/DataCorrectionV2'

const mapStateToProps = ({ dataCorrectionV2, loading, studyLock, searchTerm }) => {
  return {
    dcfList: dataCorrectionV2?.dcfList || [],
    dcfDetail: dataCorrectionV2?.dcfDetail,
    loading: loading.general,
    studyLock,
    searchTerm,
  }
}

const mapDispatchToProps = { ...actions }

export default connect(mapStateToProps, mapDispatchToProps)(DataCorrectionV2Page)
